<template>
<div class="px-1">
	<h5 class="fw-bold fs-5 mb-2">Вибір періоду часу</h5>
		<p class="mb-2 paragraph-indent">
			Панель вибору періоду розташована над таблицею.
		</p>
		<strong>Доступні періоди</strong>
		<ul class="mb-2">
			<li>"Не переглянуто" - всі події з моменту останього підтвердження перегляду.</li>
			<li>"24 год" - 24 години з поточного моменту.</li>
			<li>"Тиждень" - останні сім днів включаючи поточний день.</li>
			<li>"Місяць" - останні 30 днів включаючи поточний день.</li>
			<li>"Довільно" - довільний період часу. Після натискання з'являються поля вводу початку та кінця періоду.</li>
		</ul>
		<p class="mb-2 paragraph-indent">
			При перегляді періоду "Не переглянуто" з'являється кнопка <span class="text-success">"Позначити переглянутими"</span> 
			яка встановлює поточний час як час пергляду всіх подій. Після натискання кнопки всі показані в "Не переглянуто" 
			події вважаються переглянутими і більше показуватись в данному періоді перегляду не будуть.
		</p>
	<h5 class="fw-bold fs-5 mb-2">Події що відслідковуються</h5>
	<ul class="mb-2">
		<li>
			<strong>{{ eventTitles.createStationWebIf }}</strong> 
		</li>
		<li>
			<strong>{{ eventTitles.updateStationWebIf }}</strong> 
			<p class="mb-2 paragraph-indent">
				Будь-яка збережена зміна налаштувань або паспорту станції.
			</p>
		</li>
		<li>
			<strong> {{ capitalizeFirstLetter(eventTitles.updateStationStabilizationParmsWebIf) }}</strong> 
			<p class="mb-2 paragraph-indent">
				Зміни параметру стабілізації або його значення через телекерування станції.
			</p>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.updateStationStabilizationParmsLockal) }}</strong>
			<p class="mb-2 paragraph-indent">
				Зміни в регістрах налаштування станції, які фіксуються при опитуванні.
			</p>
			Регістри що фіксуються
			<ul class="mb-2">
				<li>Регістр параметру стабілізації (струм, потенціал, напруга) </li>
				<li>Регістр цільового струму</li>
				<li>Регістр цільової напруги</li>
				<li>Регістр цільового потенціалу</li>
			</ul>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.createReport) }}</strong>
			<p class="mb-2 paragraph-indent">
				Успішне формування звіту станції або організації
			</p>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.lightning) }}</strong>
			<p class="mb-2 paragraph-indent">
				Поруч зі станцією виявлено блискавку
			</p>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.alert) }}</strong>
			<p class="mb-2 paragraph-indent">
				Станція надіслала сповіщення
			</p>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.stationPowerInputOutOfRange) }}</strong>
			<p class="mb-2 paragraph-indent">
				Живлення станції претнуло нижню або верхню межу. 
				Напруга живлення станції вимірюється сервісним модулем. 
				Межі напруги живлення встановлюються в налаштуваннях сервісного модуля станції.
			</p>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.unitConnection) }}</strong>
			<p class="mb-0 paragraph-indent">
				Кожна зміна статусу св'язку модулів станції.
			</p>
			<p class="mt-0 paragraph-indent fst-italic">
				Зауважте, що втрата зв'зку фіксується після кількох невдалих спроб зв'язатись з модулем.
			</p>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.failure) }}</strong>
			<p class="mb-0 paragraph-indent">
				Метрики модулів станції що вказують на аварії. Перелік метрик:
			</p>
			<ul class="ms-3">
				<li v-for="metric of Station.failureMetrics" :key="metric">
					{{ capitalizeFirstLetter(Station.failureTitle(metric)) }}
				</li>
			</ul>
		</li>
		<li>
			<strong>{{ capitalizeFirstLetter(eventTitles.stationBoxDoorState) }}</strong>
			<p class="mb-0 paragraph-indent">
				Зміни стану дверей шафи станції.<br/>
				Для фіксації стану дверей шафи станції необхідно призначити один з охоронних 
				контурів сервісного модуля на "{{ ServiceUnit.securityCircuitPurposeNames.box_door }}".
			</p>
		</li>
	</ul>
</div>
</template>




<script>
// import MenuIcon from '@/components/Icons/MenuIcon.vue'
import { eventTitles } from '@/composables/events.js'
import { capitalizeFirstLetter } from '@/helpers.js'
import { ServiceUnit } from '@/models/serviceUnit';
import { Station } from '@/models/station.js'

export default {
	components: {
		// MenuIcon,
	},

	setup() {
		return {
			eventTitles,
			capitalizeFirstLetter,
			ServiceUnit,
			Station,
		}
	}
}
</script>